import { useModuleGate } from '../lib/moduleGate';

/**
 * True when the roster and its qualification dimensions are on: People &
 * Capacity shows Roles, a scenario may derive its pools from the roster, and
 * work units / priorities may declare capability, credential and named-resource
 * requirements. Canonical gate (§2.7): resource_roster workspace module + flag.
 *
 * When off, every scenario plans against anonymous pools exactly as it did
 * before — rough-cut is a supported mode forever, not a fallback.
 */
export function useResourceRosterEnabled(): boolean {
  return useModuleGate('resource_roster');
}
